import { useMutation } from 'react-query';
import { TaskCenterService } from '../constants';
import type { CreateTasksRequest, UpdateTaskRequest, DeleteTaskRequest, ListTasksRequest } from '../types';

export const useTaskCenterMutations = () => {
  const taskCreateMutation = useMutation((params: CreateTasksRequest) => TaskCenterService.CreateTasks(params));

  const taskUpdateMutation = useMutation((params: UpdateTaskRequest) => TaskCenterService.UpdateTask(params));

  const taskDeleteMutation = useMutation((params: DeleteTaskRequest) => TaskCenterService.DeleteTask(params));

  const getTaskByTaskDetailsMutation = useMutation((params: ListTasksRequest) => TaskCenterService.ListTasks(params));

  return {
    taskCreateMutation,
    taskDeleteMutation,
    taskUpdateMutation,
    getTaskByTaskDetailsMutation,
  };
};
